/** Chiavi dei parametri numerici tracciati in nutrition_record (allineate all'API) */
export type NutritionChartParamKey =
	| 'total_weight'
	| 'body_fat_percentage'
	| 'total_lean_mass'
	| 'skeletal_muscle_mass'
	| 'total_body_water'
	| 'intracellular_water'
	| 'circ_chest'
	| 'circ_waist'
	| 'circ_abdomen'
	| 'circ_hips'
	| 'circ_arm_relaxed'
	| 'circ_arm_contracted'
	| 'circ_forearm'
	| 'circ_thigh'
	| 'circ_calf'
	| 'ratio_waist_shoulders'
	| 'ratio_chest_waist'
	| 'ratio_arms_calves'
	| 'ratio_thigh_waist';

export interface NutritionChartParamOption {
	key: NutritionChartParamKey;
	label: string;
	unit: string;
}

/** Parametri tracciabili per il grafico con etichetta e unità di misura */
export const NUTRITION_CHART_PARAMS: NutritionChartParamOption[] = [
	{ key: 'total_weight', label: 'Peso totale', unit: 'kg' },
	{ key: 'body_fat_percentage', label: 'Massa grassa (%)', unit: '%' },
	{ key: 'total_lean_mass', label: 'Massa magra', unit: 'kg' },
	{ key: 'skeletal_muscle_mass', label: 'Massa muscolare scheletrica', unit: 'kg' },
	{ key: 'total_body_water', label: 'Acqua corporea totale', unit: 'L' },
	{ key: 'intracellular_water', label: 'Acqua intracellulare', unit: 'L' },
	{ key: 'circ_chest', label: 'Circonferenza torace', unit: 'cm' },
	{ key: 'circ_waist', label: 'Circonferenza vita', unit: 'cm' },
	{ key: 'circ_abdomen', label: 'Circonferenza addome', unit: 'cm' },
	{ key: 'circ_hips', label: 'Circonferenza fianchi', unit: 'cm' },
	{ key: 'circ_arm_relaxed', label: 'Braccio rilassato', unit: 'cm' },
	{ key: 'circ_arm_contracted', label: 'Braccio contratto', unit: 'cm' },
	{ key: 'circ_forearm', label: 'Avambraccio', unit: 'cm' },
	{ key: 'circ_thigh', label: 'Coscia', unit: 'cm' },
	{ key: 'circ_calf', label: 'Polpaccio', unit: 'cm' },
	{ key: 'ratio_waist_shoulders', label: 'Rapporto vita/spalle', unit: '' },
	{ key: 'ratio_chest_waist', label: 'Rapporto torace/vita', unit: '' },
	{ key: 'ratio_arms_calves', label: 'Rapporto braccia/polpacci', unit: '' },
	{ key: 'ratio_thigh_waist', label: 'Rapporto coscia/vita', unit: '' },
];

export const DEFAULT_NUTRITION_CHART_PARAM: NutritionChartParamKey = 'total_weight';

export function getParamOption(key: NutritionChartParamKey): NutritionChartParamOption | undefined {
	return NUTRITION_CHART_PARAMS.find((p) => p.key === key);
}

export function getParamLabel(key: NutritionChartParamKey): string {
	return getParamOption(key)?.label ?? key;
}

export function getParamUnit(key: NutritionChartParamKey): string {
	return getParamOption(key)?.unit ?? '';
}
